import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import TrackerPage from './pages/TrackerPage';
import TutorPage from './pages/TutorPage';
import AdminPage from './pages/AdminPage';
import './index.css';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="bg-hikari min-h-screen flex items-center justify-center">
        <div className="orb orb-mint"></div>
        <div className="orb orb-violet"></div>
        <div className="content-wrapper text-center">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#2DD4BF] to-[#3B82F6] flex items-center justify-center mx-auto mb-4 animate-pulse">
            <span className="text-[#0A0B10] text-xl">✦</span>
          </div>
          <p className="text-[#94A3B8]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Public Route - redirect to tracker if already logged in
function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="bg-hikari min-h-screen flex items-center justify-center">
        <div className="orb orb-mint"></div>
        <div className="content-wrapper text-center">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#2DD4BF] to-[#3B82F6] flex items-center justify-center mx-auto mb-4 animate-pulse">
            <span className="text-[#0A0B10] text-xl">✦</span>
          </div>
          <p className="text-[#94A3B8]">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/tracker" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } 
      />
      <Route 
        path="/register" 
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        } 
      />
      <Route 
        path="/tracker" 
        element={
          <ProtectedRoute>
            <TrackerPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tutor" 
        element={
          <ProtectedRoute>
            <TutorPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
